var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardIco2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2913 7.67073L12.9388 2.5924C11.9579 1.80407 10.3721 1.80407 9.40043 2.58323L3.04793 7.67073C2.33293 8.23907 1.8746 9.4399 2.03043 10.3382L3.2496 17.6349C3.46959 18.9366 4.71626 19.9907 6.03626 19.9907H16.3029C17.6138 19.9907 18.8696 18.9274 19.0896 17.6349L20.3088 10.3382C20.4554 9.4399 19.9971 8.23907 19.2913 7.67073Z",
    fill: "#2C2B83"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 12,
    r: 2,
    fill: "#E9E9FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIco2);
export default __webpack_public_path__ + "static/media/dashboard-ico2.472a755bc00de3fb98ce508d28bf96ec.svg";
export { ForwardRef as ReactComponent };